import { gql } from 'apollo-angular';

export const mutationSendOrder = gql`
mutation sendOrder ($operationID: String, $params: String ) {
    SendOrder(operationID: $operationID, params: $params ) {
        ID
    }
}
`

